module.exports = __webpack_public_path__ + "static/img/sideText.89f5a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sideText.png
// module id = em+B
// module chunks = 1